import React, { useEffect, createRef } from "react";
import ImageCards from "../../images/po-cards.png";
import ImageTech1 from "../../images/tech-img-1.png";
import ImageTech2 from "../../images/tech-img-2.png";
import ImageTech3 from "../../images/tech-img-3.png";
import ImageTech4 from "../../images/tech-img-4.png";
import ImageTech5 from "../../images/tech-img-5.png";
import ImageTech6 from "../../images/tech-img-6.png";
import lottie from 'lottie-web';
import InView from 'react-intersection-observer';
import animation from '../../icons/svg_animations/Cards_Animation/Cards_Animation.json';
import LazyLoad from 'react-lazyload';
//import AOS from 'aos';
import 'aos/dist/aos.css'

export default function Testimonial() {
  let animationContainer = createRef();

  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    
    AOS.init({
      once: true,
    });
    
    // const anim = lottie.loadAnimation({
    //   container: animationContainer.current,
    //   renderer: "svg",
    //   loop: false,
    //   autoplay: true,
    //   animationData: animation
    // });

  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  useEffect(() => {
    
  }, []);
  return (
    <div>
      <div className="engineering-breakthroughs-section section-gap-large">
        <div className="container">
          <div className="row d-flex flex-wrap">
              <div className="col">
                <h3>Engineering Breakthroughs</h3>
                <p>PhysioOutcomes wanted to offer this platform to many providers using the Software-as-a-Service (SaaS) model, and it was also planning to launch more add-ons and apps on the same platform. The platform also had to be HIPAA-ready from day-0, and it must offer an extensive library of pre-built content for each MSK condition - HD videos, images, surveys, and more that providers can instantly use.</p> 

                <p>Rapidops's engineering team developed a cloud-native and multi-tenant platform architecture. We implemented many patterns such as microservices, API-first, Content Delivery Network (CDN), containerization to make the platform scalable, reliable, and extendable.  We carefully picked the modern tech stack that is fast, agile, cost-effective, and aligned with the core platform needs.</p>
                
                <ul className="engineering-technology-list">
                  <li data-aos="zoom-in" data-aos-delay="50"><LazyLoad offset={500}><img src={ImageTech1} title="Elastic" alt="Elastic" width="39px" /></LazyLoad></li>
                  <li data-aos="zoom-in" data-aos-delay="100"><LazyLoad offset={500}><img src={ImageTech2} title="Node" alt="Node" width="39px" /></LazyLoad></li>
                  <li data-aos="zoom-in" data-aos-delay="150"><LazyLoad offset={500}><img src={ImageTech3} title="Angular" alt="Angular" width="39px" /></LazyLoad></li>
                  <li data-aos="zoom-in" data-aos-delay="200"><LazyLoad offset={500}><img src={ImageTech4} title="MySQL" alt="MySQL" width="39px" /></LazyLoad></li>
                  <li data-aos="zoom-in" data-aos-delay="250"><LazyLoad offset={500}><img src={ImageTech5} title="AWS" alt="amazon web services" width="47px" /></LazyLoad></li>
                  <li data-aos="zoom-in" data-aos-delay="300"><LazyLoad offset={500}><img src={ImageTech6} title="Redis" alt="Redis" width="39px" /></LazyLoad></li>
                </ul>
              </div>
              <div className="col right-images">
                  <InView as="div" onChange={(inView) => {
                    if (inView && animation)
                      lottie.loadAnimation({
                        container: animationContainer.current,
                        renderer: "svg",
                        loop: true,
                        autoplay: true,
                        animationData: animation
                      });
                  }} triggerOnce={true}>
                  <div className="card-animation-container" ref={animationContainer} />
                </InView>
              </div>
          </div>
        </div>
      </div>
    
      <div className="cb-testimonial-section section-gap-large po-testimonial">
        <div className="container">
          <blockquote>
            <h6>
              Enable every orthopedic to positively impact the way patients and employees live, work and recover using innovative emerging technologies.
            </h6>
            <div className="blockquote-author d-flex align-v-center">
              <div className="blockquote-detail">
                <p>Nishit Patel - VP of Delivery, Rapidops</p>
              </div>
            </div>
          </blockquote>
        </div>
      </div>

      <div className="testimonial-content">
        <div className="container">
            <div className="testimonial-content-inner">
                <h3>Automating the end-to-end patient journey </h3>
                <p>Providers do not have much time to engage with each patient manually because of the low doctor-patient ratio. So, we built a unique pathway automation engine from scratch that makes providers productive without being impersonal to their patients. PhysioOutcomes designed pre-built pathways for all MSK conditions that automatically send messages, exercise videos, pain surveys, and reminders to patients based on the standardized treatment protocols. The only thing providers need to do is add a patient to the pathway and sit back. The platform will engage patients on their behalf, track their progress daily, and keep providers in the loop. No manual effort is required!</p>
            </div>
        </div>
      </div>
    </div>
  );
}
